import React from 'react';
import { testimonials } from '../data/coachSystem';
export function TestimonialsSection() {
  return <section className="bg-char py-11 sm:py-14" aria-labelledby="testimonials-title" data-id="element-127" data-mp="20royptz7746b">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-128" data-mp="1n0tvoybdrhan">
        <span className="mx-auto mb-4 block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-129" data-mp="1r1dsg0s1kiw9" />
        <h2 id="testimonials-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-[2rem]" data-id="element-130" data-mp="1d0tf3k4wbfa5">
          What coaches say
        </h2>

        <ul className="mt-6 grid gap-3.5 sm:gap-5 lg:grid-cols-3" data-id="element-131" data-mp="1439bi4jk96wd">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-xl border border-char-line bg-char-light p-5 shadow-card" data-id="element-132" data-mp="2yf7hlxmkpmo1">
              <span className="mb-3 block h-[2px] w-8 rounded-full bg-orange/70" aria-hidden="true" data-id="element-133" data-mp="32eon2r202jt7" />
              <blockquote className="text-[0.92rem] leading-relaxed text-ivory-soft" data-id="element-134" data-mp="2q39g07xibpaw">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto border-t border-char-line pt-3.5" data-id="element-135" data-mp="34tgnxtpw1pxc">
                <p className="text-[0.85rem] font-semibold text-ivory" data-id="element-136" data-mp="2zst2dnkfi1ai">
                  {testimonial.name}
                </p>
                <p className="mt-0.5 text-[0.78rem] text-ivory-dim" data-id="element-137" data-mp="2c4jk2vmfbvo4">
                  {testimonial.role}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}